<div class="fixed inset-0 flex flex-col items-center justify-center overflow-clip bg-[#2D303C] z-[9999]">
  <ng-lottie [options]="lottieOptions()" class="w-auto h-[276px]"></ng-lottie>
  <div class="w-full px-4 mt-7.5">
    <div class="h-[31px] max-w-[221px] mx-auto px-1.5 flex items-center rounded-full bg-white/68 overflow-hidden">
      <div class="h-[17px] rounded-full transition-all duration-300 blur-[1px]" [style.width.%]="progress()" [style.background]="gradient"></div>
    </div>
  </div>
  <img src="/images/gradient.webp" class="w-full h-auto absolute bottom-0 left-0 -z-1 pointer-events-none" width="390" height="400" alt="Gradient" />
</div>
